var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: _vm.documentType + '-history', params: { id: _vm.document.document_id, lang: _vm.lang } },"rel":"nofollow"}},[_vm._t("default",function(){return [_vm._v(" hist ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }